import { render, staticRenderFns } from "./TransportOrderMulti.vue?vue&type=template&id=e106e480&scoped=true"
import script from "./TransportOrderMulti.vue?vue&type=script&lang=js"
export * from "./TransportOrderMulti.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderMulti.vue?vue&type=style&index=0&id=e106e480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e106e480",
  null
  
)

export default component.exports